"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M24 4.1A19.9 19.9 0 1 0 43.9 24 19.9 19.9 0 0 0 24 4.1zm12.563 12.587L22.018 35.341a1.208 1.208 0 0 1-.875.461h-.072a1.2 1.2 0 0 1-.85-.352l-7.785-7.795a1.2 1.2 0 0 1 0-1.7l1.326-1.325a1.2 1.2 0 0 1 1.7 0l5.338 5.351 12.408-15.9a1.2 1.2 0 0 1 1.686-.21L36.352 15a1.2 1.2 0 0 1 .211 1.687z" })
);

